var DashboardModule = (function () {
    function DashboardModule() {
    }
    return DashboardModule;
}());
export { DashboardModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard.module.ts.pre-build-optimizer.js